import { ILanguageManagerService } from './languagemanager.types';
import { http } from '@/shared/https'

export class LanguageManagerService implements ILanguageManagerService {
    readAllDataFromAPI(lang: string): any {
        return http.get(`api/LanguageManager/List/${lang}`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data;
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }

    saveData(lang: string, entity: any) {
        return http.post(`api/LanguageManager/${lang}`, entity).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {

            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }

    getTableData(url: string, entity: any) {
        return http.post(`${url}`, entity).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
    }

    updateTableData(url: string, entity: any) {
        return http.post(`${url}`, entity).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
    }

    getLanguages(): any {
        return http.get(`api/LanguageManager/Languages`)
        .then((resp: any) => {
            return resp.data;
        });
    }
}